(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ffsd-garment-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ffsd-garment-preview')) {
  customElements.define('ffsd-garment-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.config = JSON.parse(this.querySelector('.ffsd-preview-config').textContent);
      this.controller = new AbortController();
      this.scope = this.closest('product-info') || this.closest('section') || document;
      this.update = () => this.refresh();
      this.scope.addEventListener('input', this.update, {signal:this.controller.signal});
      this.scope.addEventListener('change', this.update, {signal:this.controller.signal});
      this.scope.addEventListener('garment-colour-change', this.update, {signal:this.controller.signal});
      this.timer = setInterval(this.update,300);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.refresh();
      });
      this.observer.observe(this.scope, {childList:true, subtree:true});
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
    optionName(value) {
      return String(value || '').replace(/^properties\[|\]$/g, '').toLowerCase().replace(/[–—]/g, '-').replace(/garments\b/g, 'garment').replace(/\s+/g, ' ').trim();
    }
    optionControl(name, id) {
      const controls = Array.from(this.scope.querySelectorAll('input,select,textarea'));
      return controls.find(control => (!['radio','checkbox'].includes(control.type) || control.checked) && ((id && control.id === id) || this.optionName(control.name) === this.optionName(name)));
    }
    selectedDesign(name, side, colour) {
      const group = this.config.kind === 'pants' ? 'leg' : side === 'front' && this.config.kind === 'zip' ? 'zip' : side;
      const prefix = 'image-swatches-' + group + '-' + colour.toLowerCase() + '_';
      const selected = Array.from(this.scope.querySelectorAll('input:checked'));
      return selected.find(control => control.id.startsWith(prefix)) || selected.find(control => this.optionName(control.name) === this.optionName(name));
    }
    refreshName(colour) {
      const name = this.optionControl('Sleeve name', 'text-sleeve-launch')?.value.trim() || '';
      const text = this.querySelector('[data-view="front"] .ffsd-preview-name');
      if (!text) return;
      text.hidden = !name || ['tank','pants'].includes(this.config.kind);
      text.textContent = name;
      text.style.color = colour === 'GREY' ? '#111' : '#32cd00';
    }
    refreshJacket(photos) {
      const name = this.optionControl('Jacket sleeve name')?.value.trim() || '';
      const companyControl = this.optionControl('Jacket Company wording');
      const company = /^yes\b/i.test(companyControl?.value || '');
      const art = {front:'https://cdn.shopify.com/s/files/1/0917/3270/5593/files/ffsd-comp-jacket-left-chest.png?v=1790616147',back:'https://cdn.shopify.com/s/files/1/0917/3270/5593/files/ffsd-comp-jacket-back-block.png?v=1790616142'};
      for (const side of ['front','back','sleeve']) {
        const figure = this.querySelector(`[data-view="${side}"]`);
        const garment = figure.querySelector('.ffsd-preview-garment');
        if (garment.getAttribute('src') !== photos[side]) garment.src = photos[side];
        const artwork = figure.querySelector('.ffsd-preview-art');
        artwork.hidden = !art[side];
        if (art[side] && artwork.getAttribute('src') !== art[side]) artwork.src = art[side];
        const text = figure.querySelector('.ffsd-preview-name');
        const label = [name, company ? 'Company' : ''].filter(Boolean).join('\n');
        text.hidden = side !== 'sleeve' || !label;
        text.textContent = side === 'sleeve' ? label : '';
        text.style.fontSize = `${Math.min(1.8, 16 / Math.max(1, ...label.split('\n').map(line => line.length)))}cqw`;
        const caption = figure.querySelector('.ffsd-preview-selection');
        caption.textContent = side === 'sleeve' ? (label || this.dataset.none) : this.dataset.included;
      }
    }
    refresh() {
      const colourField = this.optionControl('Garment colour');
      if (!colourField && !['tank','jacket'].includes(this.config.kind)) return;
      const colour = colourField ? colourField.value.toUpperCase() : 'BLACK';
      const photos = this.config.photos[colour];
      if (!photos) { this.hidden = true; return; }
      this.hidden = false;
      if (this.config.kind === 'jacket') { this.refreshJacket(photos); return; }
      this.refreshName(colour);
      const backEnabled = /^yes$/i.test(this.optionControl('Back design added', 'select-back-launch')?.value || '');
      for (const side of (['tank','pants'].includes(this.config.kind) ? ['front'] : ['front','back'])) {
        const figure = this.querySelector(`[data-view="${side}"]`);
        const garment = figure.querySelector('.ffsd-preview-garment');
        const artwork = figure.querySelector('.ffsd-preview-art');
        const caption = figure.querySelector('.ffsd-preview-selection');
        if (garment.getAttribute('src') !== photos[side]) garment.src = photos[side];
        const name = `${this.config.kind === 'pants' ? 'Leg' : side === 'front' ? 'Front' : 'Back'} design - ${side === 'front' && this.config.kind === 'zip' ? 'zip ' : ''}${colour.toLowerCase()} garment`;
        const chosen = (side === 'front' || backEnabled) ? this.selectedDesign(name, side, colour) : null;
        let url = chosen ? this.config.art[name + '||' + chosen.value] : null;
        if (chosen && !url) {
          const label = this.scope.querySelector(`label[for="${CSS.escape(chosen.id)}"]`);
          const candidate = label?.querySelector('img')?.getAttribute('src');
          if (candidate && /^https:\/\//.test(candidate)) url = candidate;
        }
        artwork.hidden = !url;
        if (url) {
          if (artwork.getAttribute('src') !== url) artwork.src = url;
          artwork.alt = chosen.value;
          artwork.dataset.placement = this.config.kind === 'pants' ? (/vertical/i.test(chosen.value) ? 'vertical' : 'thigh') : chosen.value.includes('LEFT CHEST') ? 'left-chest' : 'centre';
        } else {
          artwork.removeAttribute('src');
          artwork.alt = '';
        }
        const text = chosen ? chosen.value + (url ? '' : ' — ' + this.dataset.unavailable) : (side === 'back' && !backEnabled ? this.dataset.none : this.dataset.choose);
        if (caption.textContent !== text) caption.textContent = text;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-colour-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-colour-gallery')) {
  customElements.define('product-colour-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.config = JSON.parse(this.querySelector('script').textContent);
      this.scope = this.closest('product-info') || this.closest('section');
      this.gallery = this.closest('media-gallery');
      if (!this.scope || !this.gallery) return;
      this.controller = new AbortController();
      this.update = () => { this.pending = true; };
      ['input','change','click'].forEach(type => this.scope.addEventListener(type,this.update,{capture:true,signal:this.controller.signal}));
      this.timer = setInterval(() => this.refresh(),300);
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
      this.controller?.abort();
    }
    normal(value) {
      return String(value || '').toLowerCase().replace(/gray/g,'grey').replace(/[^a-z0-9]+/g,' ').trim();
    }
    colourName(value) {
      return /^(garment )?colou?r$/.test(this.normal(value).replace(/^options |^properties /,''));
    }
    selectedColour() {
      const inputs = [...this.scope.querySelectorAll('input:checked,select')];
      const globo = inputs.find(el => this.normal(el.name) === 'garment colour');
      if (globo) return globo.value;
      const field = inputs.find(el => this.colourName(el.name) || this.colourName(el.closest('fieldset')?.querySelector('legend')?.textContent?.split(':')[0]) || this.colourName(el.closest('.product-form__input')?.querySelector('label')?.textContent));
      if (field) return field.value;
      const index = this.config.options.findIndex(name => this.colourName(name));
      const id = this.scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      return this.config.variants.find(v => String(v.id) === id)?.options[index] || '';
    }
    match(colour) {
      const images = this.config.media.filter(m => m.type === 'image');
      const key = this.normal(colour);
      const explicit = images.find(m => this.normal(m.alt).includes('colour ' + key + ' front'));
      if (explicit) return explicit;
      const index = this.config.options.findIndex(name => this.colourName(name));
      const assigned = this.config.variants.filter(v => this.normal(v.options[index]) === key && v.media);
      const linked = assigned.map(v => images.find(m => m.id === v.media)).find(m => m && !this.config.variants.some(v => v.media === m.id && this.normal(v.options[index]) !== key));
      if (linked) return linked;
      const words = value => ' ' + this.normal(value).replace(/athleticheather/g,'athletic heather') + ' ';
      let matches = images.filter(m => words((m.alt || '') + ' ' + m.url.split('?')[0].split('/').pop()).includes(' ' + key + ' '));
      if (!matches.length && key === 'grey') matches = images.filter(m => /\b(athletic heather|grey heather)\b/.test(words(m.url.split('?')[0].split('/').pop())));
      if (String(this.config.productId) === '10006172795193') matches = matches.filter(m => !m.url.includes('atcy2800'));
      if (matches.length === 1) return matches[0];
      return matches.find(m => /\bfront\b/.test(words(m.url))) || matches.find(m => /\bflat\b/.test(words(m.url))) || null;
    }
    refresh() {
      const colour = this.selectedColour();
      if (!colour) return;
      const key = this.normal(colour);
      if (key === this.lastColour && !this.pending) return;
      this.pending = false;
      if (key === this.lastColour) return;
      const media = this.match(colour);
      if (media && typeof this.gallery.setActiveMedia !== 'function') return;
      const target = media && [...this.gallery.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === this.dataset.section + '-' + media.id);
      if (media && !target) return;
      this.lastColour = key;
      this.gallery.toggleAttribute('data-colour-unavailable',!media);
      this.querySelector('p').hidden = !!media;
      if (media) this.gallery.setActiveMedia(target.dataset.mediaId,true);
      this.scope.dispatchEvent(new CustomEvent('garment-colour-change',{detail:{colour}}));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
